const spans = document.querySelectorAll('.opening .copy span');
function typeText(el, speed = 100) {
  return new Promise(resolve => {
    const text = el.dataset.text;
    let i = 0;

    function type() {
      if (i < text.length) {
        el.textContent += text[i];
        i++;
        setTimeout(type, speed);
      } else {
        resolve();
      }
    }

    type();
  });
}
async function run() {
  for (const span of spans) {
    await typeText(span);
  }
}
setTimeout(run, 3500);

const videos = document.querySelectorAll('.content-link-map video');
videos.forEach(video => {
  video.playbackRate = 0.7;
});


const swiper = new Swiper('.vertical-swiper', {
  direction: 'vertical',
  loop: true,
  slidesPerView: 4,
  spaceBetween: 20,
  speed: 4000,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
    pauseOnMouseEnter: true,
  },

  breakpoints: {
    0: {
      direction: 'horizontal',
      slidesPerView: 3,
    },
    1025: {
      direction: 'vertical',
      slidesPerView: 4,
    }
  }
});

const mq = window.matchMedia('(hover: hover) and (pointer: fine)');
if (mq.matches) {
    document.querySelectorAll('.cir .ttl, .cir .syn').forEach(el => {
        const parent = el.closest('.cir');

        el.addEventListener('mouseenter', () => {
            parent.classList.add('active');
        });

        el.addEventListener('mouseleave', () => {
            parent.classList.remove('active');
        });
    });
}

const targets = [
    {
        trigger: '.cir_about .ttl, .cir_about .syn',
        close: '.content-about .cls-btn',
        content: '.content-about',
        extra: '.whole_white'
    },
    {
        trigger: '.cir_event .ttl, .cir_event .syn',
        close: '.content-event .cls-btn',
        content: '.content-event',
        extra: '.whole_blue'
    },
    {
        trigger: '.cir_goods .ttl, .cir_goods .syn',
        close: '.content-goods .cls-btn',
        content: '.content-goods',
        extra: '.whole_white'
    },
    {
        trigger: '.cir_contact .ttl, .cir_contact .syn',
        close: '.content-contact .cls-btn',
        content: '.content-contact',
        extra: '.whole_blue'
    },
];

const closeAll = () => {
    targets.forEach(item => {
        const contentEl = document.querySelector(item.content);
        if (contentEl) contentEl.classList.remove('active');

        if (item.extra) {
            const extraEl = document.querySelector(item.extra);
            if (extraEl) extraEl.classList.remove('active');
        }
    });
};

targets.forEach(item => {
    document.querySelectorAll(item.trigger).forEach(el => {
        el.addEventListener('click', (e) => {
            e.stopPropagation();

            const current = document.querySelector(item.content);
            const isActive = current && current.classList.contains('active');

            closeAll();

            if (!isActive && current) {
                current.classList.add('active');

                if (item.extra) {
                    const extraEl = document.querySelector(item.extra);
                    if (extraEl) extraEl.classList.add('active');
                }
            }
        });
    });

    document.querySelectorAll(item.close).forEach(el => {
        el.addEventListener('click', (e) => {
            e.stopPropagation();
            closeAll();
        });
    });
});

document.addEventListener('click', (e) => {
    const activeItem = targets.find(item => {
        const content = document.querySelector(item.content);
        return content && content.classList.contains('active');
    });

    if (!activeItem) return;

    const activeContent = document.querySelector(activeItem.content);

    if (activeContent && e.target.closest(activeItem.content)) {
        return;
    }

    closeAll();
});

document.querySelectorAll('.cir_community .ttl, .cir_community .syn').forEach(el => {
    el.addEventListener('click', () => {
        const circle = document.querySelector('.cc_circle');
        const content = document.querySelector('.content-community');

        if (circle) circle.classList.add('active');

        setTimeout(() => {
            if (content) {
                content.style.display = 'block';
                content.style.opacity = 0;

                content.style.transition = 'opacity 0.5s';
                requestAnimationFrame(() => {
                    content.style.opacity = 1;
                });
            }
        }, 800);
    });
});
document.querySelectorAll('.content-community .back span').forEach(el => {
    el.addEventListener('click', () => {
        const circle = document.querySelector('.cc_circle');
        const content = document.querySelector('.content-community');

        if (content) {
            content.style.opacity = 1;
            content.style.transition = 'opacity 0.5s';

            requestAnimationFrame(() => {
                content.style.opacity = 0;
            });

            setTimeout(() => {
                content.style.display = 'none';
            }, 800);
        }

        if (circle) {
            circle.classList.remove('active');
        }
    });
});

const tabs = document.querySelectorAll('.event-tabs .tab');
const contents = document.querySelectorAll('.et-contents .content');
tabs.forEach(tab => {
    tab.addEventListener('click', () => {
        const id = tab.dataset.tab;

        tabs.forEach(t => t.classList.remove('is-active'));
        contents.forEach(c => c.classList.remove('is-active'));

        tab.classList.add('is-active');
        document.querySelector(`.content[data-content="${id}"]`)
            .classList.add('is-active');
    });
});

document.addEventListener('DOMContentLoaded', () => {
  const link = document.querySelector('.link_x a');
  const img = link.querySelector('img');

  const original = img.src;
  const hoverSrc = 'https://shop.hownever.com/cdn/shop/t/4/assets/x-logo-black.png?v=128083408124283117651774955156';

  link.addEventListener('mouseenter', () => {
    img.src = hoverSrc;
  });

  link.addEventListener('mouseleave', () => {
    img.src = original;
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const targets = document.querySelectorAll(`
    .cir_about .syn,
    .cir_event .syn,
    .cir_community .syn,
    .cir_goods .syn,
    .cir_contact .syn
  `);

  if (!targets.length) return;

  targets.forEach(el => {
    el.style.transition = 'transform 0.2s ease';
  });

  setInterval(() => {
    const randomEl = targets[Math.floor(Math.random() * targets.length)];

    randomEl.style.transform = 'scale(1.3)';

    setTimeout(() => {
      randomEl.style.transform = 'scale(1)';
    }, 500);
  }, 1500);
});